module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel16-9545630a0c07afd6abc45fca85f78d31.jpg";